export default function PlayStoreIcon() {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_952_670)">
        <path
          d="M8.89531 6.40937L2.85781 0.355469L10.5387 4.76328L8.89531 6.40937ZM1.28281 0C0.927344 0.185938 0.689453 0.525 0.689453 0.965234V13.0348C0.689453 13.475 0.927344 13.8141 1.28281 14L8.30195 6.99727L1.28281 0ZM12.9121 6.16875L11.3016 5.23633L9.50508 7L11.3016 8.76367L12.9449 7.83125C13.4371 7.44297 13.4371 6.5625 12.9121 6.16875ZM2.85781 13.6473L10.5387 9.23945L8.89531 7.59609L2.85781 13.6473Z"
          fill="#F0F3F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_952_670">
          <rect fill="white" height="14" width="14" />
        </clipPath>
      </defs>
    </svg>
  );
}
